import React from 'react'
// import LoginSignup from './Login/LoginSignup'
// import { Counter } from './Login/Counter'
// import { TodoList } from './Login/TodoList'
// import { Greeting } from './Login/Greeting'
// import { ToggledMessage } from './Login/ToggledMessage'
// import { SearchableList } from './Login/SearchableList'
// import UserProfile from './CodingPractice/UserProfile'
// import { StatePractice } from './CodingPractice/StatePractice'
// import { EventHandling } from './CodingPractice/EventHandling'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { WeatherApp } from './WeatherApp/WeatherApp'
function App() {
  return (
    <>
      {/* <h1>User Profiles</h1> */}
      {/* <UserProfile name="John Doe" age={28} location='New York' />
      <UserProfile name="Jane Smith" age={32} location='London' />
      <UserProfile name="Alice Jhonson" age={24} location='Sydney' /> */}
      <Router>
        <Routes>
          <Route path='/' element={<WeatherApp/>} />
        </Routes>
      </Router>
    </>
  )
}

export default App




